// extracted by mini-css-extract-plugin
export var highlightFade = "_30-4";
export var highlighted = "_30-3";
export var table = "_30-1";
export var tableContainer = "_30-0";
export var totalsRow = "_30-2";